module.exports = __webpack_public_path__ + "static/media/icon_pessoasuspeita.827e169d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_pessoasuspeita.svg
// module id = 524
// module chunks = 0